import { cva } from 'class-variance-authority';
import React from 'react';

interface Props {
    checked?: boolean;
    disabled?: boolean;
}

const containerVariants = cva(
    'w-4 h-4 flex items-center justify-center border rounded-full bg-white transition-all duration-150',
    {
        variants: {
            variant: {
                default: 'border-gray-300 cursor-pointer',
                checked: 'border-primary-500 cursor-pointer',
                disabled: 'border-gray-200 bg-gray-100 cursor-not-allowed opacity-60'
            }
        },
        defaultVariants: {
            variant: 'default'
        }
    }
);

const circleVariants = cva('w-2 h-2 rounded-full transition-transform duration-150', {
    variants: {
        variant: {
            default: 'bg-transparent scale-0',
            checked: 'bg-primary-500 scale-100',
            disabled: 'bg-gray-400 scale-100'
        }
    },
    defaultVariants: {
        variant: 'default'
    }
});

const CheckBox: React.FC<Props> = ({ checked = false, disabled = false }) => {
    const variant = disabled ? 'disabled' : checked ? 'checked' : 'default';

    return (
        <div className={containerVariants({ variant })}>
            <div className={circleVariants({ variant })} />
        </div>
    );
};

export default CheckBox;

